var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.SkinComponent,{tag:"component",attrs:{"code":_vm.code},on:{"save":_vm.validate},model:{value:(_vm.board),callback:function ($$v) {_vm.board=$$v},expression:"board"}})
}
var staticRenderFns = []

export { render, staticRenderFns }